import h from "trader-hyperscript";
import { Source } from "trader.ts/types/source";
import { dyn } from "trader.ts/ui";
import { Field, Parsing } from "trader.ts/ui.forms";
import * as style from "./../../styles/style.css.classes";
import * as FA from "./../../styles/fontawesome.css.classes";
import { isNil } from "../lib/istype";
import { isEqual } from "../lib/isequal";

export function radioField<T>(opts: {
  initial: T | null;
  values: T[];
  show: (t: T) => string;
  render?: (s: string, selected: boolean, onclick: () => void) => HTMLElement;
  containerClass?: string;
  label?: string;
  saveAndLoadInitialValToLocalStorage?: string;
}): Field<T> {
  const lsKey = !isNil(opts.saveAndLoadInitialValToLocalStorage)
    ? "trader_forms_radiofield_" + opts.saveAndLoadInitialValToLocalStorage
    : null;
  const fromLs = lsKey ? localStorage.getItem(lsKey) : null;
  // We save the SHOWN value into LS, not the "identifier"
  const initial = !isNil(fromLs)
    ? fromLs
    : !isNil(opts.initial)
    ? opts.show(opts.initial)
    : null;

  const initialFound = opts.values.find((opt) => opts.show(opt) === initial);
  const initialParsed = !isNil(initialFound)
    ? {
        tag: "parsed" as const,
        parsed: initialFound,
      }
    : { tag: "initial" as const };

  const parsingS: Source<Parsing<T>> = new Source(initialParsed);

  function render() {
    const options = dyn(parsingS, (parsing) =>
      opts.values.map((v) => {
        const shown = opts.show(v);
        return (opts.render || radioFieldDefaultRender)(
          shown,
          parsing.tag === "parsed" && isEqual(parsing.parsed, v),
          () => {
            parsingS.set({ tag: "parsed", parsed: v });
            if (lsKey) {
              localStorage.setItem(lsKey, shown);
            }
          },
        );
      }),
    );
    return (
      <article>
        <label>{opts.label || ""}</label>
        <div className={opts.containerClass}>{options}</div>
      </article>
    );
  }

  return { s: parsingS, render, cleanup: () => {} };
}

function radioFieldDefaultRender(
  s: string,
  selected: boolean,
  onclick: () => void,
): HTMLElement {
  return (
    <button
      style={
        selected
          ? ` background-color: var(--grey-200); `
          : `color: var(--grey-400);`
      }
      className={style.button_em_down}
      onclick={onclick}
    >
      {selected ? <i className={FA.icon_check_solid}></i> : <i></i>}
      {s}
    </button>
  );
}

export function radioFieldCheckboxRender(
  s: string,
  selected: boolean,
  onclick: () => void,
): HTMLElement {
  const i = <input type="checkbox" onclick={onclick} checked={selected} />;
  return (
    <label className={style.checkbox}>
      {i} {s}
    </label>
  );
}

export function radioFieldCheckboxRenderInputLike(
  s: string,
  selected: boolean,
  onclick: () => void,
  opts?: { style?: string },
): HTMLElement {
  const i = <input type="checkbox" onclick={onclick} checked={selected} />;
  return (
    <label
      className={style.checkbox + style.input_like}
      style={opts?.style + ";margin-bottom: 2px;"}
    >
      {i} {s}
    </label>
  );
}
